/* Base translations · Scoping — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): scoping. */
export const I18N_BASE_SCOPING = {
  en: {
    scoping: {
      title: "Scoping",
      refresh: "Refresh",
      om: "Overall materiality",
      pm: "Performance materiality",
      ct: "Clearly trivial",
      notSetIn105a: "Not set in 105(a) — open",
      setCtInMateriality: "Set clearly trivial in 105(a)",
      empty: "No FS heads in mapping — assign accounts in FS Mapping first.",
      significantRisk: "Significant risk linked (set in Response Plan)",
      suggestionChanged: "Suggestion changed since decision was saved.",
      reasonPlaceholder: "Reason required (decision differs from suggestion)",
      col: { head: "FS head", cy: "CY balance", py: "PY balance",
              mvmt: "Movement", pctOm: "% of overall materiality",
              risks: "Risks", qual: "Qualitatively material",
              suggestion: "Suggestion", decision: "Decision",
              reason: "Reason", isa: "ISA basis" },
      decision: {
        not_decided: "— Not decided —",
        full: "Full testing",
        sap: "Substantive analytics",
        ar: "Analytical review only",
      },
      pySource: {
        prior_year_tb: "Prior-year TB",
        prior_year_gl: "Prior-year GL (closing balance)",
        prior_gl_closing: "Derived from prior-year GL",
        not_available: "PY not available (prior-year GL has no opening-balance journal)",
        none: "No prior-year data",
      },
      guard: {
        material: "Material head — substantive procedures required.",
        significant: "Significant risk — tests of details required unless controls are tested.",
      },
    },
  },
  ar: {
    scoping: {
      title: "تحديد النطاق",
      refresh: "تحديث",
      om: "الأهمية النسبية الإجمالية",
      pm: "الأهمية النسبية للأداء",
      ct: "الحد الجوهري بشكل واضح",
      notSetIn105a: "غير مُحدَّد في 105(a) — افتح",
      setCtInMateriality: "حدِّد الحد الجوهري في 105(a)",
      empty: "لا توجد بنود قوائم مالية — عيّن الحسابات في تعيين القوائم المالية أولًا.",
      significantRisk: "يوجد خطر مهم مرتبط (يُحدَّد في خطة الاستجابة)",
      suggestionChanged: "تغيّر الاقتراح منذ حفظ القرار.",
      reasonPlaceholder: "السبب مطلوب (القرار يختلف عن الاقتراح)",
      col: { head: "البند", cy: "رصيد السنة الحالية",
              py: "رصيد السنة السابقة", mvmt: "التغيّر",
              pctOm: "النسبة من الأهمية الإجمالية", risks: "المخاطر",
              qual: "جوهري نوعيًا", suggestion: "الاقتراح",
              decision: "القرار", reason: "السبب", isa: "الأساس المعياري" },
      decision: {
        not_decided: "— لم يُتخذ قرار —",
        full: "اختبار كامل",
        sap: "إجراءات تحليلية جوهرية",
        ar: "مراجعة تحليلية فقط",
      },
      pySource: {
        prior_year_tb: "ميزان مراجعة السنة السابقة",
        prior_year_gl: "دفتر الأستاذ للسنة السابقة (الرصيد الختامي)",
        prior_gl_closing: "مشتق من دفتر أستاذ السنة السابقة",
        not_available: "السنة السابقة غير متاحة (دفتر الأستاذ للسنة السابقة بلا قيد أرصدة افتتاحية)",
        none: "لا توجد بيانات للسنة السابقة",
      },
      guard: {
        material: "بند جوهري — يلزم تنفيذ إجراءات جوهرية.",
        significant: "خطر مهم — يلزم اختبار التفاصيل ما لم تُختبر الضوابط.",
      },
    },
  },
};

export default I18N_BASE_SCOPING;
